var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3492 0H21.9842C19.4271 0.00813061 16.9771 1.02752 15.169 2.83565C13.3609 4.64377 12.3415 7.09377 12.3333 9.65083V12.3333H0V74H61.6667V61.6667H64.3492C66.9062 61.6585 69.3562 60.6391 71.1644 58.831C72.9725 57.0229 73.9919 54.5729 74 52.0158V9.65083C73.9919 7.09377 72.9725 4.64377 71.1644 2.83565C69.3562 1.02752 66.9062 0.00813061 64.3492 0V0ZM55.5 67.8333H6.16667V18.5H12.3333V52.0158C12.3415 54.5729 13.3609 57.0229 15.169 58.831C16.9771 60.6391 19.4271 61.6585 21.9842 61.6667H55.5V67.8333ZM67.8333 52.0158C67.8253 52.9374 67.4556 53.8189 66.8039 54.4706C66.1523 55.1223 65.2707 55.492 64.3492 55.5H21.9842C21.0626 55.492 20.1811 55.1223 19.5294 54.4706C18.8777 53.8189 18.508 52.9374 18.5 52.0158V9.65083C18.508 8.72927 18.8777 7.84772 19.5294 7.19605C20.1811 6.54438 21.0626 6.17472 21.9842 6.16667H64.3492C65.2707 6.17472 66.1523 6.54438 66.8039 7.19605C67.4556 7.84772 67.8253 8.72927 67.8333 9.65083V52.0158Z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5833 15.4167H27.75V21.5833H58.5833V15.4167Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5833 27.75H27.75V33.9167H58.5833V27.75Z",
    fill: "#949494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5833 40.0833H27.75V46.25H58.5833V40.0833Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.5ca4158f.svg";
export { ForwardRef as ReactComponent };